import {
  Box,
  Button,
  Dialog,
  IconButton,
  Slide,
  Typography,
  useTheme,
} from "@mui/material";
import React from "react";
import { BoxCheck, Close, LocationCheck, Phone } from "../../icons";
import { Item } from "./components/Item";
import { TransitionProps } from "@mui/material/transitions";

type DialogPickupProps = {
  open: boolean;
  onClose?: () => void;
};

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<unknown>;
  },
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export const DialogPickup = ({ open, onClose }: DialogPickupProps) => {
  const theme = useTheme();
  return (
    <React.Fragment>
      <Dialog
        keepMounted
        disableScrollLock
        open={open}
        onClose={onClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        slots={{
          transition: Transition,
        }}
        slotProps={{
          paper: {
            style: {
              marginInline: 2,
              padding: 20,
              borderRadius: 15,
              backgroundColor: theme.palette.background.paper,
              backdropFilter: "saturate(180%) blur(20px)",
            },
          },
        }}
      >
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          gap={2}
          mb={5}
        >
          <Box display="flex" alignItems="center" gap={2}>
            <BoxCheck sx={{ width: 18, height: 18 }} />
            <Typography
              id="modal-modal-title"
              variant="h5"
              sx={{ color: theme.palette.secondary[500] }}
            >
              Store Pickup
            </Typography>
          </Box>

          <IconButton sx={{width: 20, height: 20}} onClick={onClose}>
            <Close />
          </IconButton>
        </Box>

        <Typography variant="body1"  sx={{color: theme.palette.secondary[700]}} fontWeight={500} mb={4}>
          Pickup Available - Usually ready within 24 hours
        </Typography>

        <Item
          value="https://maps.app.goo.gl/fp5GF7Dh12t4r98w7"
          icon={<LocationCheck sx={{ width: 13, height: 13 }} />}
          target="_blank"
          primaryLabel="Address"
          secondaryLabel="7003 Presidents Drive Unit 600, Orlando, FL, 32809"
        />

        <Item
          value="tel:+13213410151"
          icon={<Phone sx={{ width: 13, height: 13 }} />}
          primaryLabel="Phone"
          secondaryLabel="+1 (321) 341-0151"
        />

        <Box display="flex" justifyContent="flex-end">
          <Button
            onClick={onClose}
            color="secondary"
            variant="contained"
            disableElevation
          >
            OK
          </Button>
        </Box>
      </Dialog>
    </React.Fragment>
  );
};
